/**
 * Subscription Category/Keep Me Informed Popup
 */
export const OPEN_SUBSCRIPTION_POPUP =
  "subscription/OPEN_KEEP_ME_INFORMED_POPUP";
export const CLOSE_SUBSCRIPTION_POPUP =
  "subscription/CLOSE_KEEP_ME_INFORMED_POPUP";
